import { type SxProps, type Theme } from "@mui/material/styles";

import Icons from "assets";

import Card, { CardBody, CardHeader, CardRow } from "components/partials/card/card";
import ContentTypeMismatchIcon from "components/partials/icon/content-type-mismatch-icon";
import { Button } from "ui/button";

import {
  useGetTouchpointContentTypesQuery,
  getDictionaryItemDescription,
} from "hooks/api/dictionary";

import { getDisplayTouchpointType } from "utilities";

import { useIsEmailWriterGenerating } from "containers/admin/clients/touchpoint/hooks/use-is-email-writer-generating";
import { TouchpointCardProps } from "containers/admin/clients/touchpoint/tab-components/details-tab/details-tab.types";

const EDIT_BUTTON_SX: SxProps<Theme> = { mt: 2 };

const ContentDetailsCard = ({ touchpoint, onEditClick, ...rest }: TouchpointCardProps) => {
  const { data: contentTypes = [] } = useGetTouchpointContentTypesQuery();
  const isEmailWriterGenerating = useIsEmailWriterGenerating();

  const contentTypeValue = (
    <div className="flex items-center gap-1.5">
      {getDictionaryItemDescription(contentTypes, touchpoint.contentType)}{" "}
      {!touchpoint.validContentType && <ContentTypeMismatchIcon customClass="size-4" />}
    </div>
  );

  return (
    <Card {...rest}>
      <div className="flex justify-between items-start mr-4">
        <CardHeader heading={`${getDisplayTouchpointType(touchpoint.type)} content details`} />
        <Button
          sx={EDIT_BUTTON_SX}
          variant="outlined"
          size="medium"
          startIcon={<Icons.Edit />}
          disabled={isEmailWriterGenerating}
          onClick={onEditClick}>
          Edit
        </Button>
      </div>
      <CardBody>
        <CardRow title="Insights Activator" value={touchpoint.insightsActivator ? "Enabled" : "Disabled"} />
        <CardRow title="Content type" value={contentTypeValue} />
        <CardRow title="Copy code" value={touchpoint.copyCode} />
        <CardRow title="Folder" value={touchpoint.folderName} />
      </CardBody>
    </Card>
  );
};

export default ContentDetailsCard;
